/** Brand social profiles — shared by marketing site and transactional email. */

export const SOCIAL_INSTAGRAM_URL = "https://www.instagram.com/menuhunter.app/";
export const SOCIAL_FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61589393105492";
export const SOCIAL_TIKTOK_URL = "https://www.tiktok.com/@menuhunter_app";

export const SOCIAL_INSTAGRAM_HANDLE = "@menuhunter.app";
export const SOCIAL_TIKTOK_HANDLE = "@menuhunter_app";
export const SOCIAL_FACEBOOK_LABEL = "MenúHunter";

/** Official coloured brand marks (site UI). Email templates keep their own PNG URLs. */
export const BRAND_SOCIALS = [
  {
    id: "instagram" as const,
    label: "Instagram",
    href: SOCIAL_INSTAGRAM_URL,
    handle: SOCIAL_INSTAGRAM_HANDLE,
    iconSrc: "/email/instagram.png",
  },
  {
    id: "facebook" as const,
    label: "Facebook",
    href: SOCIAL_FACEBOOK_URL,
    handle: SOCIAL_FACEBOOK_LABEL,
    iconSrc: "/email/facebook.png",
  },
  {
    id: "tiktok" as const,
    label: "TikTok",
    href: SOCIAL_TIKTOK_URL,
    handle: SOCIAL_TIKTOK_HANDLE,
    iconSrc: "/brand/social/tiktok.svg",
  },
] as const;

export type BrandSocialId = (typeof BRAND_SOCIALS)[number]["id"];
